module.exports = __webpack_public_path__ + "img/wallet_02_non_1.893d64ff.png";